export interface DefaultToolbarLink {
  id: number;
  label: DefaultToolbarLinkLabel;
  to: string;
  icon: string;
  isDisabled: boolean;
}

export enum DefaultToolbarLinkLabel {
  verification = "Реквизиты",
  application = "Создание заявки",
  history = "История",
  settings = "Настройки",
  wallet = "Кошелек",
}

export enum DefaultToolbarLinkIcon {
  verification = "verification",
  application = "application",
  history = "history",
  settings = "settings",
  wallet = "wallet",
}
